import { z } from "zod";

/**
 * One scan of a shipping label, together with the zone it was scanned in.
 *
 * `code` is the load carrier unit's id — the QR printed on the label — and never a transport
 * order's. A unit outlives the leg it is on: the label is printed once at sign-off, and every
 * later leg of the chain is raised after that paper exists, so a label naming a leg would be
 * wrong from the second hop onwards.
 *
 * `zoneCode` is what the person holding the box scanned off the wall, and it is **required**. It
 * is the only thing that can attest to where they are standing — without it the server took the
 * leg's own destination as the truth and recorded an arrival wherever the box happened to be.
 * Three forms are accepted, since a hall is labelled by whoever built it: a uuid from a printed
 * QR, the zone's own number, or its name.
 *
 * What the scan *means* is derived from the pair rather than sent, because a handheld in a gloved
 * hand reliably supports one gesture and not a choice of verbs: the leg's state and which of its
 * two ends was scanned decide between picking up, delivering and taking a carry over.
 */
export const postTransportOrderScanSchema = z.object({
	code: z.string().min(1),
	zoneCode: z.string().min(1),
});

export type PostTransportOrderScanSchema = z.infer<typeof postTransportOrderScanSchema>;
